import type { ModelContext } from '@assistant-ui/react';
import { createContext } from 'react';

/** Represents an AI agent with specific capabilities and model configuration. */
export interface AssistantAgent {
  name: string;
  description: string;
  /** Returns the model context configuration for this agent's LLM interactions. */
  getModelContext: () => ModelContext;
}

/** Function to register an agent, returns cleanup function to unregister. */
export type RegisterAgentFunction = (name: string, agent: AssistantAgent) => () => void;

/** Central context for managing assistant configuration and registered agents. */
export interface AssistantContextType {
  name: string;
  description: string;
  system: string;
  /** Map of registered agent names to their implementations. */
  agents: Record<string, AssistantAgent>;
  registerAgent: RegisterAgentFunction;
  /** Name of the currently active agent, or null if none active. */
  activeAgent: string | null;
}

const getInitialAssistantContext = (): AssistantContextType => ({
  name: '',
  description: '',
  system: '',
  agents: {},
  registerAgent: () => () => {
    // No-op unregister function for default context
  },
  activeAgent: null,
});

export const AssistantContext = createContext<AssistantContextType>(getInitialAssistantContext());
